import {Component, ViewChild} from "@angular/core";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {EntityData, field, identifier, ReportModel} from "@fedeltapointofsale/data-client";
import {SurchargeSearchPageComponent} from "../surcharge-search-page/surcharge-search-page.component";

export class SurchargeReportSelectionData extends EntityData<SurchargeReportSelectionData> {
    @identifier surchargeId: number;
    @field name: string;
}

@Component({
    selector: "wbo-surcharge-report-selection",
    templateUrl: "./surcharge-report-selection-control.component.html"
})
export class SurchargeReportSelectionControlComponent {
    SurchargeSearchPageComponent = SurchargeSearchPageComponent;

    fieldName: string = "surcharges";

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromSurcharge(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((surcharge: any) => surcharge.surchargeId === item.surchargeId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }
}
